import React from "react";

export interface ContentCardProps {
  title?: string;
  text: string;
  isLinkCard?: boolean;
  imgSrc?: string;
  imgElement?: React.ReactNode;
  actionElement?: React.ReactNode;
}

const ContentCard: React.FC<ContentCardProps> = ({
  title,
  text,
  isLinkCard,
  imgSrc,
  imgElement,
  actionElement,
}) => {
  const cardContent = (
    <div className={`content-card ${!isLinkCard && "content-card-small"}`}>
      {imgSrc && (
        <div className="content-card-img">
          <img
            src={imgSrc}
            alt="icon"
            className="simple-icon"
            width={43}
            height={43}
          />
        </div>
      )}
      {!imgSrc && imgElement}
      <div className="content-card-desc">
        {title && <h3 className="content-card-title">{title}</h3>}
        <p className="content-card-text">{text}</p>
      </div>
      {actionElement}
    </div>
  );

  return isLinkCard ? (
    <div className="content-card-with-link">
      <a href="">{cardContent}</a>
    </div>
  ) : (
    cardContent
  );
};

export default ContentCard;
